import userSettingsApi from './userSettingsApi';

const upsertUserSetting = async (
  userId: number | string,
  app: string,
  key: string,
  value: string
) => {
  try {
    const { data } = await userSettingsApi.put(
      `/${encodeURIComponent(String(userId))}/${encodeURIComponent(app)}/${encodeURIComponent(key)}`,
      { value },
      { headers: { 'Content-Type': 'application/json;charset=UTF-8' } }
    );
    return data;
  } catch (error) {
    console.error('[upsertUserSetting] Failed:', error);
    throw error;
  }
};

export default upsertUserSetting;
